import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export const getClaimRead = (userId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_CLAIM_READ_PROVIDER_LIST_REQUEST });

  return api.claim.providerList.getClaimRead(userId)
    .then((res: any) => {

      dispatch({
        type: types.GET_CLAIM_READ_PROVIDER_LIST_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_CLAIM_READ_PROVIDER_LIST_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getClaimReadWrite = (userId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_CLAIM_READ_WRITE_PROVIDER_LIST_REQUEST });

  return api.claim.providerList.getClaimReadWrite(userId)
    .then((res: any) => {

      dispatch({
        type: types.GET_CLAIM_READ_WRITE_PROVIDER_LIST_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_CLAIM_READ_WRITE_PROVIDER_LIST_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
  